import { render, staticRenderFns } from "./PMPagesWrapper.vue?vue&type=template&id=cf2bb186&"
import script from "./PMPagesWrapper.vue?vue&type=script&lang=ts&"
export * from "./PMPagesWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PMPagesWrapper.vue?vue&type=style&index=0&id=cf2bb186&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports